import React from 'react';
import {
  QuickFilterBasicSkeleton,
  QuickFilterColorSkeleton,
  QuickFilterListSkeleton,
  QuickFilterRateSkeleton,
  QuickFilterTagsSkeleton,
} from './QuickFilterComponentsSkeleton';
import styled from 'styled-components';
import { Skeleton } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
import { QuickFiltersWrapper } from '../../quickFilters/styles/QuickFilters.styles';

interface Props {}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const HeadlineWrapper = styled.div`
  padding-bottom: ${SYS_SPACE_FIXED_300};
`;

export const QuickFilterSkeleton: React.FC<Props> = () => {
  return (
    <QuickFiltersWrapper>
      <Container>
        <HeadlineWrapper>
          <Skeleton variant="rectangular" width="150px" height="32px" margin={['6px', 0, 0, 0]} />
        </HeadlineWrapper>
        <QuickFilterTagsSkeleton />
        <QuickFilterBasicSkeleton />
        <QuickFilterBasicSkeleton />
        <QuickFilterRateSkeleton />
        <QuickFilterTagsSkeleton />
        <QuickFilterBasicSkeleton />
        <QuickFilterListSkeleton />
        <QuickFilterListSkeleton />
        <QuickFilterListSkeleton />
        <QuickFilterColorSkeleton />
        <QuickFilterColorSkeleton />
      </Container>
    </QuickFiltersWrapper>
  );
};
